import React from "react";
const AllTests=()=>{
return(
    <>
    AllTests
    </>
);
}
export default AllTests